import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = { id: "two-fa-form" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Preferred Method", -1)
const _hoisted_4 = { class: "radio-group primary bold" }
const _hoisted_5 = { class: "radio-buttons align-items-start flex-md-row flex-column" }
const _hoisted_6 = {
  for: "participant-phone",
  class: "d-flex pdr-15"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pdl-10" }, "Mobile Phone", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", { class: "pdt-10" }, "Phone number for Authentication", -1)
const _hoisted_10 = { class: "fw-medium pdt-10" }
const _hoisted_11 = {
  for: "participant-email",
  class: "d-flex"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "pdl-10" }, "Email Code", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("small", { class: "pdt-10" }, "Email Address for Authentication", -1)
const _hoisted_14 = { class: "fw-medium pdt-10" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, " Security Questions ", -1)
const _hoisted_17 = {
  key: 1,
  class: "w-full sm-pdb-40"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-plus" })
], -1)
const _hoisted_19 = {
  key: 2,
  class: "d-flex w-full gap-2 sm-pdb-20 flex-row justify-content-md-start justify-content-end"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary action-btn"
}, " Update ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_UpdateEmail = _resolveComponent("UpdateEmail")!
  const _component_UpdatePhone = _resolveComponent("UpdatePhone")!
  const _component_UpdatePassword = _resolveComponent("UpdatePassword")!
  const _component_SecurityQuestionSelect = _resolveComponent("SecurityQuestionSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, {
      error: $setup.localErrors?.General,
      success: $setup.success
    }, null, 8, ["error", "success"]),
    _createVNode(_component_MessageCard, {
      message: "If you wish to change your password, email or security question, please do    so in the corresponding boxes below.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_UpdateEmail),
          _createVNode(_component_UpdatePhone),
          _createVNode(_component_UpdatePassword),
          _createElementVNode("form", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["radio-button flex-column w-fit align-items-start rounded", { 'bg-white': $setup.preferredMethod == 'P' }])
                }, [
                  _createElementVNode("label", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "participant-phone",
                      name: "method",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.preferredMethod) = $event)),
                      class: "pdr-5",
                      value: "P",
                      disabled: !$setup.phone,
                      onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.updatePreferredMethod('P')))
                    }, null, 40, _hoisted_7), [
                      [_vModelRadio, $setup.preferredMethod]
                    ]),
                    _hoisted_8
                  ]),
                  ($setup.preferredMethod == 'P' && !$setup.loadingPreferred)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_9,
                        _createElementVNode("p", _hoisted_10, [
                          _createTextVNode(_toDisplayString($setup.phone) + " ", 1),
                          _createElementVNode("i", {
                            class: "iatse-icon-edit ml-10 fw-bold plan-modal",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updatePhone && $setup.updatePhone(...args)), ["prevent"]))
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["radio-button flex-column w-fit align-items-start rounded", { 'bg-white': $setup.preferredMethod == 'E' }])
                }, [
                  _createElementVNode("label", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "participant-email",
                      name: "method",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.preferredMethod) = $event)),
                      class: "pdr-5",
                      value: "E",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.updatePreferredMethod('E')))
                    }, null, 544), [
                      [_vModelRadio, $setup.preferredMethod]
                    ]),
                    _hoisted_12
                  ]),
                  ($setup.preferredMethod == 'E' && !$setup.loadingPreferred)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_13,
                        _createElementVNode("p", _hoisted_14, [
                          _createTextVNode(_toDisplayString($setup.userEmailSet) + " ", 1),
                          _createElementVNode("i", {
                            class: "iatse-icon-edit ml-10 fw-bold plan-modal",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateEmail && $setup.updateEmail(...args)), ["prevent"]))
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            (!$setup.phone)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, "Please add your phone number above to enable this option."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("form", {
            id: "security-questions-form ",
            class: "form account-settings",
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateSecurityQuestion && $setup.updateSecurityQuestion(...args)), ["prevent"]))
          }, [
            _hoisted_16,
            ($setup.selectedQuestions.length)
              ? (_openBlock(), _createBlock(_component_SecurityQuestionSelect, {
                  key: 0,
                  label: "Security Question",
                  index: 1,
                  userQuestion: $setup.userQuestions[0],
                  "selected-question": $setup.selectedQuestions[0],
                  questionId: $setup.userQuestions[0]?.ID,
                  resetInputs: $setup.resetInputs,
                  options: $setup.securityQuestionsArray,
                  errors: $setup.localErrors,
                  showAddNewQuestion: $setup.showAddNewQuestion,
                  onHandleQuestions: $setup.handleQuestions,
                  onToggleEdit: $setup.editQuestion,
                  onDelete: $setup.removeQuestion
                }, null, 8, ["userQuestion", "selected-question", "questionId", "resetInputs", "options", "errors", "showAddNewQuestion", "onHandleQuestions", "onToggleEdit", "onDelete"]))
              : _createCommentVNode("", true),
            (!$setup.selectedQuestions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.addNewQuestion && $setup.addNewQuestion(...args)), ["prevent"])),
                    class: "btn btn-secondary add-btn"
                  }, [
                    _hoisted_18,
                    _createTextVNode(" Add New Security Question ")
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.hasEditable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.discardChanges && $setup.discardChanges(...args)), ["prevent"])),
                    class: "btn btn-secondary action-btn"
                  }, " Discard ")
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ]))
  ], 64))
}